import store from "@/store";
import { toDecimal } from "@/components/models/utils";

export function getValueUnit(value, type) {
  const units = store.state.units;
  const unit = units.find((u) => u.id === type);
  if (value === null) return "-";
  if (unit) {
    if (unit.unit && unit.unit.indexOf("|") > -1) {
      const mm = unit.unit.split(",")[0].match(/\d+:[^#]+/g);
      let vala = mm.find((u) => u.split(":")[0] === value);
      if (vala) {
        return vala
          ? vala.split(":")[1].replace("#", "").replace("*", "")
          : "-";
      }
      //状态
      const uu = unit.unit.split(",")[1].split("|");
      let value2 = value;
      let val = [];
      uu.forEach((u, i) => {
        let l = Math.pow(2, uu.length - 1 - i);
        if (value2 >= l) {
          value2 = value2 - l;
          if (u) {
            val.push(u);
          }
        }
      });
      return val.join(",");
    } else if (unit.unit && unit.unit.indexOf("#") > -1) {
      const uu = unit.unit.match(/\d+:[^#]+/g);
      const val = uu.find((u) => u.indexOf(value) > -1);
      return val ? val.split(":")[1].replace("#", "").replace("*", "") : "-";
    } else {
      //时间类型
      if (unit.type === 6) {
        return value === 0
          ? "-"
          : intervalTime(value * 1000, new Date().valueOf());
      } else {
        return (
          toDecimal(value, unit.precision) + (unit.unit ? ` ${unit.unit}` : "")
        );
      }
    }
  } else {
    return "-";
  }
}
